module.exports = video.js;